export enum MachineLearningExperimentType {
  'DataAnomalyDetection' = 'Data Anomaly Detection',
  'TimeseriesForecasting' = 'Timeseries Forecasting',
}

export type IMachineLearningExperiment = BaseMachineLearningExperiment &
  (DataAnomalyDetectionExperiment | TimeseriesForestcastingExperiment);

export type BaseMachineLearningExperiment = {
  id: string | null;
  type: MachineLearningExperimentType | null;
  name: string | null;
  dataOwnerId: string | null;
  description: string | null;
  baseEntity: string | null;
  baseEntityColumns: string[] | null;
  joinedEntities: { [key: string]: { [key: string]: string[] } } | null;
  hiddenProperties: string[] | null;
  splitColumn: string | null;
  disabled: boolean;
};

export type DataAnomalyDetectionExperiment = {
  type: MachineLearningExperimentType.DataAnomalyDetection;
  modelConfiguration: {
    unsupervisedModel: 'IsolationForest';
    unsupervisedModelConfiguration: {
      n_estimators: number;
      max_samples: number | null | 'auto';
      contamination: number;
      random_state: number;
    };
    supervisedModel: 'RandomForest';
    supervisedModelConfiguration: {
      n_estimators: number | null;
      max_samples: number | null | 'auto';
      random_state: number | null;
    };
    supervisedModelUri: string | null;
  };
};

export type TimeseriesForestcastingExperiment = {
  type: MachineLearningExperimentType.TimeseriesForecasting;
  modelConfiguration: null;
};
